module.exports = __webpack_public_path__ + "img/android-studio-user.09715b93.svg";